// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"19":"def897ee","478":"3aeddb0f","924":"2daf5de2"}[chunkId] + ".css";
};